const messages = {
    buttons: {
        productBrochures: "Bekijk",
    },
    index: {
        title: "INFORMATIE OVER PRODUCTEN",
        description: "Download hier de nieuwste brochures en flyers van onze Bridgestone- en Firestone-banden.",
        categories: {
            productBrochures: {
                title: "Productbrochures",
                description: "Brochures van Bridgestone- en Firestone-bandenreeksen",
            },
            bDrive: {
                title: "Productafbeeldingen",
                description: "Actuele afbeeldingen vindt u in ons B-DRIVE-portaal om te downloaden.",
            },
        
          kickback: {
            description: "Deelnemende bedrijven ontvangen tegoeden in de vorm van een bonus op basis van de ingediende verkoopcijfers.",
          },}
    }
};

export default {
    messages,
};
